export default __webpack_public_path__ + "21ea2d4b76c60a9828188bf16be6ddaa.png";